exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zgxq[data-v-1aa1d4a0],.zgxq-card[data-v-1aa1d4a0]{height:100%;width:100%}", ""]);

// exports
